import { PrescriptionPadStep } from '@/components/PatientPageV2/components/PrescriptionPad';
import { FF_FLOWER_DISPENSE_LIMIT_V2 } from '@/constants/featureFlags';
import { useFeatureFlags } from '@/hooks';
import { useAppStore, usePrescriptionDispenseLimitExceeded } from '@/state-management';
import { useMemo } from 'react';

export const useDispenseLimitExceededActions = () => {
  const { flags } = useFeatureFlags();
  const ffFlowerDispenseLimitV2Enabled = flags[FF_FLOWER_DISPENSE_LIMIT_V2];
  const {
    prescriptionPad: { step: createScriptStep, dispenseNote },
  } = useAppStore.use.prescriptionAssistant();
  const { isExceeded } = usePrescriptionDispenseLimitExceeded();

  const shouldDisable = useMemo(
    () =>
      ffFlowerDispenseLimitV2Enabled &&
      createScriptStep === PrescriptionPadStep.Confirm &&
      isExceeded &&
      !dispenseNote.length,
    [ffFlowerDispenseLimitV2Enabled, createScriptStep, isExceeded, dispenseNote],
  );

  return {
    showAlert: isExceeded,
    showNote: ffFlowerDispenseLimitV2Enabled && isExceeded,
    shouldDisable,
  };
};
